<template>
    <div class="container-fluid">
        <el-container>
            <el-header height="15%">
                <el-row type="flex" justify="space-between">
                    <el-col>
                        <h4>Слайды на главной</h4>
                    </el-col>
                    <el-col>
                        <el-button type="success" @click="goToPage('main-slide/create')">Добавить новый слайд</el-button>
                    </el-col>
                </el-row>
            </el-header>

            <el-main height="80%">
                <!-- <el-form aria-label="Поиск" >
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="Поиск по названию">
                                <el-col :span="10">
                                    <el-input v-model="query.q"  @change="getMainSlides()"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="Сортировка">
                                <el-select v-model="query.sort" :width="300" @change="getMainSlides()">
                                    <el-option
                                    v-for="item in sortConfig"
                                    :key="item.field"
                                    :value="item.field"
                                    :label="item.title"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form> -->

                <el-table
                :data="mainSlides"
                style="width: 100%"
                empty-text="Нет слайдов">
                    <el-table-column
                        prop="id"
                        label="Id"
                        width="50"
                    />

                    <el-table-column
                        prop="title"
                        label="Название"
                        width="300"
                    />

                    <el-table-column
                        prop="link"
                        label="Ссылка"
                        width="300"
                    />

                    <el-table-column
                        prop="btn_text"
                        label="Текст кнопки"
                    />

                    <el-table-column
                        prop="sort"
                        label="Сортировка"
                    />

                    <el-table-column
                        label="Активность"
                    >
                        <template slot-scope="scope">
                            <p v-if="!mainSlides[scope.$index].activity">Нет</p>
                            <p v-if="mainSlides[scope.$index].activity">Да</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                    fixed="right"
                    label="Действия"
                    width="400">
                        <template slot-scope="scope">
                            <el-button
                               size="mini"
                               @click="updateRow(scope.$index)">Изменить</el-button>

                            <el-button
                               size="mini"
                               type="danger"
                               @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
<!-- 
            <el-footer height="5%">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="paginator.meta.total"
                    :current-page.sync="current"
                    @current-change="getPage(current)"
                    :page-size="paginator.meta.per_page"
                    :page-count="paginator.meta.last_page"
                    :hide-on-single-page="true"
                >
                </el-pagination>
            </el-footer> -->
            </el-container>
    </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/main-slider-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
  name: "Advantages",
  data: function (){
    return{
      status:0,
      mainSlides:[],
      paginator:[],
      current:0,
      sortConfig,
      query:{
          q:'',
          sort: sortConfig[0].field
      }
    }
  },
  mounted() {
    this.getMainSlides();
  },
  computed: {
    activeSort() {
        const result = this.sortConfig.find((e) => e.field === this.query.sort)
        return result ? result.options  : undefined
    },
    queryComputed() {
        const sort = this.activeSort
        const q = this.query.q
        const result = {}
        let isChange = false;
        if (sort) {
            isChange = true
            result['sort'] = sort;
        }
        if (q) {
            isChange = true
            result['q']=q
        }
        return isChange ? result : undefined
    }
  },
  methods:{
    getQuery(query) {
      const qs = require('qs');
      let q
      if (query) {
        q = query
      } else {
        q = this.queryComputed ? `?${qs.stringify(this.queryComputed)}` : ''
      }
      return q;
    },
    getPage: function(pageNum) {        
        if (pageNum !== null) {
            const qs = require('qs');
            const qProps = this.queryComputed ? `&${qs.stringify(this.activeSort)}` : undefined
            const q = `page=${pageNum}${qProps}`
            this.getMainSlides(q)
        }
    },
    getMainSlides: function (query){        
        const q = this.getQuery(query)    
        this.$store.commit(SETPRELOADER_STATE, true)          
        axios.get('content/main-slide' + q).then((response)=>
        {
            this.mainSlides = response.data;
            // this.paginator = response.data;
        }
        ).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        })
        .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    goToPage: function (path){
        this.$router.push(path);
    },
    deleteRow: function (index) {
        let id = this.mainSlides[index].id;

        axios.delete('content/main-slide/'+id).then(()=>{
            this.$notify.success('Слайд удален')
            this.getMainSlides();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    hideRow: function (index) {
        let id = this.mainSlides[index].id;

        axios.post('content/main-slide/'+id+'/hide').then(()=>{
            this.$notify.success('Слайд скрыт')
            this.getMainSlides();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    restoreRow: function (index) {
        let id = this.mainSlides[index].id;
        axios.post('content/main-slide/'+id+'/restore').then(()=>{
            this.$notify.success('Слайд востановлен')
            this.getMainSlides();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    updateRow: function (index) {
        let id = this.mainSlides[index].id;
        this.$router.push('/main-slide/'+id+'/update');
    },
  }
}
</script>

<style scoped>

</style>